import { render } from "./AlertImage.component.vue?vue&type=template&id=633aac80&scoped=true&ts=true"
import script from "./AlertImage.component.vue?vue&type=script&lang=ts"
export * from "./AlertImage.component.vue?vue&type=script&lang=ts"

import "./AlertImage.component.vue?vue&type=style&index=0&id=633aac80&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633aac80"]])

export default __exports__